module.exports = __webpack_public_path__ + "img/hainanhedian.7ac35d89.png";